<app-loader></app-loader>
<div class="delete-outer">
    <div class="modal-inner-wraper">
        <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M65.5 33C65.5 50.9492 50.9493 65.5 33 65.5C15.0507 65.5 0.5 50.9492 0.5 33C0.5 15.0507 15.0507 0.5 33 0.5C50.9493 0.5 65.5 15.0507 65.5 33Z" stroke="#D72525"/>
            <g clip-path="url(#clip0_11404_10821)">
            <path d="M41 24.9427L40.0573 24L33 31.0573L25.9427 24L25 24.9427L32.0573 32L25 39.0573L25.9427 40L33 32.9427L40.0573 40L41 39.0573L33.9427 32L41 24.9427Z" fill="#D72525"/>
            </g>
            <defs>
            <clipPath id="clip0_11404_10821">
            <rect width="16" height="16" fill="white" transform="translate(25 24)"/>
            </clipPath>
            </defs>
            </svg>
                
        <h3>{{headerText}}</h3>
        <p [innerHTML]="bodyText"></p>
        <div class="yes-no-btn">
            <p-button label="Yes" (onClick)="comingFromInvoice ? cancelBookingInvoiceFunc() :cancelBookingFunc()"
                class="btn-continue"></p-button>
            <p-button label="No" (onClick)="cancel()" class="btn-continues"></p-button>
        </div>
    </div>
</div>